import { Language } from '../ts/customTypes';
import { Pages } from '../ts/customTypes';

// Background

// Icons
import IconBenefits from '../icons/content/benefits.svg';

// Content Images
import processStepTeileidentifikation1Svg from '../content/nl/process-parts-identification-step1.svg';
import processStepTeileidentifikation2Svg from '../content/nl/process-parts-identification-step2.svg';
import processStepTeileidentifikation3Svg from '../content/nl/process-parts-identification-step3.svg';
import processStepTeileidentifikation4Svg from '../content/nl/process-parts-identification-step4.svg';

import processStepLagerergaenzung1Svg from '../content/nl/process-storage-step1.svg';
import processStepLagerergaenzung2Svg from '../content/nl/process-storage-step2.svg';
import processStepLagerergaenzung3Svg from '../content/nl/process-storage-step3.svg';
import processStepLagerergaenzung4Svg from '../content/nl/process-storage-step4.svg';

import contactImage from '../content/mail-contact.png';
import testimonial1 from '../content/testimonial1.jpg';
import testimonial2 from '../content/testimonial2.jpg';
import { IconBestellschnittstelle } from '../../lib/components/content/IconBestellschnittstelle';
import { IconKatalogschnittstelle } from '../../lib/components/content/IconKatalogschnittstelle';
import { IconVerfuegbarkeitsschnittstelle } from '../../lib/components/content/IconVerfuegbarkeitsschnittstelle';
import { IconNettopreisschnittstelle } from '../../lib/components/content/IconNettopreisschnittstelle';

import landingpageSmallImage1 from '../content/landingpage-img-1.webp';
import landingpageSmallImage2 from '../content/landingpage-img-2.webp';
import landingpageBigImage from '../content/image-landingpage-big.jpg';

import imageKatalogschnittstelle from '../content/image-katalogschnittstelle.jpg';
import imageBestellschnittstelle from '../content/image-bestellschnittstelle.jpg';
import imageNettopreisschnittstelle from '../content/image-nettopreisschnittstelle.jpg';
import imageVerfuegbarkeitsschnittstelle from '../content/image-verfuegbarkeitsschnittstelle.jpg';
import flag from '../flags/flag-nl.svg';

export const nl: Language = {
    id: 'NL',
    languageName: 'Nederlands',
    flagUrl: flag,
    headerHeading: 'eProcurement',
    backToLandingPageLabel: 'Overzicht',
    infolayer: {
        text: (
            <>
                <p>Het verheugt ons dat u meer wilt weten over de OMNIplus eProcurement interfaces.</p>
                <p>
                    De website is geoptimaliseerd voor weergave op een desktopcomputer of tablet. Weergave op uw mobiele
                    apparaat is helaas niet mogelijk.
                </p>
                <p>
                    Via het webadres van deze pagina kunt u de inhoud ook op andere eindapparaten openen. Stuur het
                    adres van deze pagina naar uw tablet of computer. Klik op de volgende link om het webadres naar het
                    klembord te kopiëren:
                </p>
            </>
        ),
        button: 'Link naar klembord kopiëren',
    },
    [Pages.LANDINGPAGE]: {
        headline: 'Inkoopproces',
        headlineWidth: 380,
        buttonContact: 'Contact',
        buttonTestimonials: 'Feedback van klanten',
        tooltips: {
            availability: 'Beschikbaarheidsinterface',
            catalogue: 'Catalogusinterface',
            identification: 'Onderdelenidentificatie',
            order: 'Bestelinterface',
            price: 'Nettoprijsinterface',
            storage: 'Bekende onderdelen\ninplannen',
        },
        background: '',
        images: {
            leftUpper: landingpageSmallImage1,
            leftLower: landingpageSmallImage2,
            big: landingpageBigImage,
        },
    },
    testimonialsPage: {
        headline: 'Feedback van klanten',
        headlineWidth: 420,
        testimonials: [
            {
                name: 'Jens-Uwe Mentel',
                imageUrl: testimonial1,
                job: 'Technische medewerker bij Usedomer Bäderbahn GmbH',
                quotes: [
                    '"Het opzetten van de nieuwe interface naar COSware heeft goed gewerkt. Hierdoor kunnen we reserveonderdelen tijdefficiënter in het systeem opnemen en bestellen."',
                ],
            },
            {
                name: 'Mirano Bitici',
                job: 'Afdelingshoofd Inkoop bij Stuttgarter Straßenbahnen AG',
                quotes: [
                    '"In een mum van tijd werd een project opgezet om de integratie van ons inkoopsysteem met OMNIplus te realiseren."',
                    '"Met name de pragmatische en doelgerichte aanpak viel op."',
                    '"Nu profiteren we bij inkoop en in onze werkplaatsen van de lagere aanschafkosten."',
                ],
            },
            {
                name: 'Richard Schallmoser',
                imageUrl: testimonial2,
                job: 'Inkoop bij Holding Graz – Kommunale Dienstleistungen GmbH',
                quotes: [
                    '"Met de implementatie hebben we het inkoopproces ook in de omgeving geoptimaliseerd. Dit bijkomend voordeel was voor ons net zo belangrijk als de interfaces zelf."',
                    '"De verbinding heeft zich al in de kortste tijd zo bewezen dat hij niet meer weg te denken is."',
                ],
            },
        ],
        footer: {
            // #Einsatz-Kundenfeedback-eProcurement-Click-Explainer#
            headline: 'Onze interfaces wordt gebruikt bij:',
            companies: [
                'Stuttgarter Straßenbahnen AG',
                'Holding Graz – Kommunale Dienstleistungen GmbH',
                'Regionalbus Leipzig GmbH',
                'Usedomer Bäderbahn GmbH',
                'EBS Public Transportation B. V.',
            ],
        },
    },
    contactPage: {
        headline: 'Contact',
        headlineWidth: 250,
        texts: [
            'Bij de implementatie van eProcurement-interfaces staan uw processen centraal. Daarom ondersteunen wij u bij uw klantspecifieke koppelingsproject voor de digitalisering van uw inkoop.',
            'Neem contact met ons op via: ',
        ],
        email: 'omniplus-eprocurement@daimlertruck.com',
        imageUrl: contactImage,
        stepsHeadline: 'Normaal gesproken verloopt elk koppelingsproject in vier stappen:',
        steps: ['Kick-off', 'Conceptueel ontwerp', 'Implementatie', 'Go-Live'],
        text: (
            <p>
                Zodra er contact is opgenomen, wordt tijdens een kick-off vastgesteld hoe eProcurement u mogelijk kan
                ondersteunen bij uw inkoopproces. Daarna wordt in de conceptuele ontwerpfase onderzocht hoe en met welke
                inspanning de implementatie eruit kan zien. Na een succesvolle testfase kan er worden overgeschakeld
                naar het nieuwe inkoopproces.
            </p>
        ),
    },
    infoPages: {
        [Pages.VERFUEGBARKEITSSCHNITTSTELLE]: {
            headline: 'Beschikbaarheidsinterface',
            icon: <IconVerfuegbarkeitsschnittstelle />,
            intro: 'De beschikbaarheid van uw onderdelen kan met behulp van de interface direct in uw klantensysteem worden opgevraagd.',
            text: (
                <p>
                    Via de beschikbaarheidsinterface kunt u de vrij beschikbare hoeveelheden voor uw benodigde
                    onderdelen opvragen. Hierbij kan niet alleen de beschikbaarheid van uw OMNIplus-servicewerkplaats
                    worden bekeken, maar ook de gehele toeleveringsketen.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Uw voordelen',
                    list: [
                        'Volledige transparantie van beschikbare leveringshoeveelheden bij uw OMNIplus-servicewerkplaats',
                        'Weergave van de beschikbaarheid in de gehele logistieke keten',
                        'Betere voorspelbaarheid in het inkoopproces',
                        'Oproepen via een REST API-interface',
                    ],
                },
            ],
            images: {
                main: imageVerfuegbarkeitsschnittstelle,
            },
        },
        [Pages.BESTELLSCHNITTSTELLE]: {
            headline: 'Bestelinterface',
            icon: <IconBestellschnittstelle />,
            intro: 'BestBestellingen direct naar OMNIplus verzenden.',
            text: (
                <p>
                    Dankzij de integratie van een bestelinterface kunnen bestelopdrachten direct aan het systeem van
                    OMNIplus worden overgedragen. Zo ontstaat er bij het bestellen in het klantensysteem geen
                    systeemonderbreking en vervalt het handmatig overdragen van de bestelinhoud, zodat de opdracht
                    sneller en nauwkeurig zoals doorgegeven wordt verwerkt. De verbinding via een interface kan
                    momenteel worden opgebouwd naar de eigen servicecenters van Daimler Buses met
                    BusWorld-classificatie.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Uw voordelen',
                    list: [
                        'Digitale inkoop van onderdelen zonder systeemonderbreking',
                        'Snellere verwerking van de bestelling door direct aanmaken van bestelopdracht in het hoofdmenu van Daimler Buses Service Center',
                        'Overdracht van een opdrachtbevestiging via de interface mogelijk',
                        'Veelzijdige verbindingsmogelijkheden: verbinding mogelijk via EDI-standaarden, cXML of een REST API-interface',
                    ],
                },
            ],
            images: {
                main: imageBestellschnittstelle,
            },
        },
        [Pages.KATALOGSCHNITTSTELLE]: {
            headline: 'Catalogusinterface',
            icon: <IconKatalogschnittstelle />,
            intro: 'Eenvoudige identificatie van de benodigde onderdelen zonder het klantsysteem te verlaten.',
            text: (
                <p>
                    Via een catalogusinterface kunnen in de OMNIplus eShop onderdelen worden geïdentificeerd en aan het
                    klantsysteem worden overgedragen. In de OMNIplus eShop-catalogus zijn uw klantspecifieke prijzen en
                    de beschikbaarheid bij uw OMNIplus-servicewerkplaats te zien.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Uw voordelen',
                    list: [
                        'Integratie van het klantspecifieke wagenpark in de OMNIplus eShop',
                        'Beschikbaarheid en afzonderlijke prijzen direct zichtbaar',
                        'Zoeken naar onderdelen op vier verschillende manieren, bijvoorbeeld via de voertuigdocumentatie in de BusParts-catalogus',
                        'Ondersteuning voor de OCI- en cXML-standaarden',
                    ],
                },
            ],
            images: {
                main: imageKatalogschnittstelle,
            },
        },
        [Pages.NETTOPREISSCHNITTSTELLE]: {
            headline: 'Nettoprijsinterface',
            icon: <IconNettopreisschnittstelle />,
            intro: 'Opvragen van uw klantspecifieke prijzen van onderdelen via de interface direct in uw klantensysteem.',
            text: (
                <>
                    <p>
                        Via de nettoprijsinterface kunt u de prijzen voor uw reserveonderdelen direct vanuit het systeem
                        van OMNIplus aan uw klantensysteem overdragen. Hierbij wordt rekening gehouden met uw
                        klantspecifieke voorwaarden en speciale acties. De prijs kan bij alle eigen Daimler Buses
                        Service Centers met BusWorld-classificatie worden opgevraagd.
                    </p>
                </>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Uw voordelen',
                    list: [
                        'Weergave van de prijs met inachtneming van uw individuele voorwaarden voor de ingeplande onderdelen',
                        'Volledige prijstransparantie, ook bij speciale prijzen en staffelkortingen',
                        'Bestel- en goedkeuringsproces volledig in het klantensysteem mogelijk',
                        'Oproepen via een REST API-interface',
                    ],
                },
            ],
            images: {
                main: imageNettopreisschnittstelle,
            },
        },
    },
    processPages: {
        [Pages.TEILEIDENTIFIKATION]: {
            headline: 'Onderdelenidentificatie via OMNIplus eShop-interface',
            headlineWidth: 790,
            infoBox: {
                headline: 'Toepassingsgebied',
                bullets: [
                    'U zoekt voor uw voertuig een onderdeel waarvan u het te bestellen onderdeelnummer niet kent. Bijvoorbeeld omdat het om een nieuw voertuigmodel gaat of omdat het benodigde onderdeel niet in uw eigen database is opgeslagen.',
                ],
            },
            steps: [
                {
                    imageUrl: processStepTeileidentifikation1Svg,
                    headline: 'OMNIplus eShop-catalogus openen',
                    content: (
                        <>
                            U kunt in uw eigen voorraadbeheersysteem de OMNIplus eShop-catalogus openen om de
                            identificatie van onderdelen te starten.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation2Svg,
                    headline: 'Onderdelenidentificatie via de OMNIplus eShop',
                    content: (
                        <>
                            In de eShop-interface kan op vier verschillende manieren het benodigde reserveonderdeel
                            worden geïdentificeerd. Naast de integratie van het individuele wagenpark biedt de eShop
                            bijvoorbeeld ook de mogelijkheid om onderdelen te zoeken via de voertuigdocumentatie in de
                            BusParts Catalog.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation3Svg,
                    headline: 'Overdracht naar klantsysteem',
                    content:
                        'Nadat de benodigde onderdelen zijn geïdentificeerd en de inhoud van het winkelmandje is samengesteld, kan de onderdeleninformatie van de OMNIplus eShop naar het klantsysteem worden overgebracht.',
                },
                {
                    imageUrl: processStepTeileidentifikation4Svg,
                    headline: 'Bestelling uit het klantensysteem',
                    content: (
                        <>
                            Via de bestelinterface wordt uw bestelling met één klik doorgestuurd naar het
                            OMNIplus-systeem en kan direct worden verwerkt.
                        </>
                    ),
                },
            ],
        },
        [Pages.LAGERERGAENZUNG]: {
            headline: 'Veel voorkomende onderdelen inplannen met behulp van beschikbaarheids- en prijsinterface',
            headlineWidth: 1240,
            infoBox: {
                headline: 'Toepassingsgebied',
                bullets: [
                    'In veel gevallen is reeds bekend welke onderdelen u nodig hebt.',
                    'Dit is bijvoorbeeld het geval als de onderdelenidentificatie reeds in de werkplaats wordt uitgevoerd en in uw systeem een bestelopdracht met de benodigde onderdeelnummers is aangemaakt.',
                    <>
                        Of u krijgt een melding in uw voorraadbeheersysteem dat de minimale voorraad van afzonderlijke
                        onderdelen wordt onderschreden. Als de leveranciersnummers reeds in de artikelstam worden
                        bijgehouden, kunt u hieronder een magazijnaanvulling plaatsen.
                    </>,
                ],
            },
            steps: [
                {
                    imageUrl: processStepLagerergaenzung1Svg,
                    headline: 'Inplanning van de in te kopen onderdelen', // #AB1-Disposition-eProcurement-Click-Explainer#
                    content:
                        'In uw voorraadbeheersysteem plant u de benodigde onderdelen in een bestelopdracht in, bijvoorbeeld om magazijnaanvullingen uit te voeren.',
                },
                {
                    imageUrl: processStepLagerergaenzung2Svg,
                    headline: 'Beschikbaarheid en prijs opvragen',
                    content: (
                        <>
                            Nadat u een bestelopdracht met de te bestellen onderdelen in uw klantensysteem hebt
                            aangemaakt, kunt u de bijbehorende beschikbaarheid en prijzen opvragen via de
                            eProcurement-interface.
                        </>
                    ),
                },
                {
                    imageUrl: processStepLagerergaenzung3Svg,
                    headline: 'Bestelopdracht controleren',
                    content:
                        'In uw klantensysteem kunt u de opgevraagde informatie over de ingeplande onderdelen laten weergeven en eventueel uw interne goedkeuringsprocessen starten.',
                },
                {
                    imageUrl: processStepLagerergaenzung4Svg,
                    headline: 'Bestelling uit het klantensysteem',
                    content:
                        'Vervolgens kunt u via de bestelinterface uw opdracht aan het systeem van OMNIplus overdragen, zodat deze direct kan worden verwerkt.',
                },
            ],
        },
    },
};
